import { ROUTES } from './routes'

/**
 * `/_/invite/decline/{token}`: the page the "thanks, but I do not want to
 * join" link of the import invite e-mail opens (F-85 §2.4). Public, no session.
 */
export const isInviteDeclinePath = (path: string): boolean => path.split('?')[0].startsWith(ROUTES.inviteDecline)

/** The token as it came in the URL. */
export const inviteDeclineTokenFrom = (path: string): string =>
  decodeURIComponent(path.split('?')[0].slice(ROUTES.inviteDecline.length).split(/[/#]/)[0] || '').trim()
